<!-- Subfrota Filter -->
<div class="form-section">
    <div class="form-group">
        <label>Subfrota</label>
        <div class="input-group">
            <input [(ngModel)]="searchControl.value" 
                type="text" 
                name="subfrota" 
                class="form-control" 
                matTooltip="Preencha para a pesquisa de subfrota"
                (input)="onInputChange($event)" 
                [matAutocomplete]="auto" 
                placeholder="digite aqui" />
            <mat-autocomplete #auto="matAutocomplete" 
                (optionSelected)='onOptionSelected($event)'
                [displayWith]="displayFn">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option.descricao}}
                </mat-option>
            </mat-autocomplete>
            <button type="button" mat-icon-button matTooltip="Pesquise a subfrota" (click)="onSubmit()">
                <mat-icon>search</mat-icon>
            </button>
            <button type="button" mat-icon-button
                matTooltip="Limpe o resultado da pesquisa de subfrota" 
                (click)="limpaFiltro()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
</div>

<!-- Selected Subfrota Details -->
<div *ngIf="subfrota" class="bg-light p-3 mt-3">
    <div class="row">
        <div class="col-md-2">
            <div class="label">Código</div>
            <div>{{subfrota.codigo}}</div>
        </div>
        <div class="col-md-4">
            <div class="label">Descrição</div>
            <div>{{subfrota.descricao}}</div>
        </div>
        <div class="col-md-4">
            <div class="label">Cidade</div>
            <div>{{subfrota.cidade}}</div>
        </div>
        <div class="col-md-2">
            <div class="label">UF</div>
            <div>{{subfrota.uf}}</div>
        </div>
    </div>
</div> 